"use strict";
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */

var _typeof = require("/app/node_modules/@babel/runtime/helpers/typeof.js").default;

var _createForOfIteratorHelper = require("/app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

require("core-js/modules/es.number.is-safe-integer.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.error.cause.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.typed-array.uint8-array.js");

require("core-js/modules/es.typed-array.at.js");

require("core-js/modules/es.typed-array.copy-within.js");

require("core-js/modules/es.typed-array.every.js");

require("core-js/modules/es.typed-array.fill.js");

require("core-js/modules/es.typed-array.filter.js");

require("core-js/modules/es.typed-array.find.js");

require("core-js/modules/es.typed-array.find-index.js");

require("core-js/modules/es.typed-array.for-each.js");

require("core-js/modules/es.typed-array.includes.js");

require("core-js/modules/es.typed-array.index-of.js");

require("core-js/modules/es.typed-array.iterator.js");

require("core-js/modules/es.typed-array.join.js");

require("core-js/modules/es.typed-array.last-index-of.js");

require("core-js/modules/es.typed-array.map.js");

require("core-js/modules/es.typed-array.reduce.js");

require("core-js/modules/es.typed-array.reduce-right.js");

require("core-js/modules/es.typed-array.reverse.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.slice.js");

require("core-js/modules/es.typed-array.some.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.subarray.js");

require("core-js/modules/es.typed-array.to-locale-string.js");

require("core-js/modules/es.typed-array.to-string.js");

require("core-js/modules/es.typed-array.from.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.string.pad-start.js");

require("core-js/modules/es.string.ends-with.js");

require("core-js/modules/es.object.keys.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bytes = exports.stringToBytes = exports.str = exports.bytesToString = exports.hex = exports.utf8 = exports.bech32m = exports.bech32 = exports.base58check = exports.base58xmr = exports.base58xrp = exports.base58flickr = exports.base58 = exports.base64url = exports.base64 = exports.base32crockford = exports.base32hex = exports.base32 = exports.base16 = exports.utils = exports.assertNumber = void 0;

function assertNumber(n) {
  if (!Number.isSafeInteger(n)) throw new Error("Wrong integer: ".concat(n));
}

exports.assertNumber = assertNumber;

function chain() {
  var wrap = function wrap(a, b) {
    return function (c) {
      return a(b(c));
    };
  };

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var encode = Array.from(args).reverse().reduce(function (acc, i) {
    return acc ? wrap(acc, i.encode) : i.encode;
  }, undefined);
  var decode = args.reduce(function (acc, i) {
    return acc ? wrap(acc, i.decode) : i.decode;
  }, undefined);
  return {
    encode: encode,
    decode: decode
  };
}

function alphabet(alphabet) {
  return {
    encode: function encode(digits) {
      if (!Array.isArray(digits) || digits.length && typeof digits[0] !== 'number') throw new Error('alphabet.encode input should be an array of numbers');
      return digits.map(function (i) {
        assertNumber(i);
        if (i < 0 || i >= alphabet.length) throw new Error("Digit index outside alphabet: ".concat(i, " (alphabet: ").concat(alphabet.length, ")"));
        return alphabet[i];
      });
    },
    decode: function decode(input) {
      if (!Array.isArray(input) || input.length && typeof input[0] !== 'string') throw new Error('alphabet.decode input should be array of strings');
      return input.map(function (letter) {
        if (typeof letter !== 'string') throw new Error("alphabet.decode: not string element=".concat(letter));
        var index = alphabet.indexOf(letter);
        if (index === -1) throw new Error("Unknown letter: \"".concat(letter, "\". Allowed: ").concat(alphabet));
        return index;
      });
    }
  };
}

function join() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (typeof separator !== 'string') throw new Error('join separator should be string');
  return {
    encode: function encode(from) {
      if (!Array.isArray(from) || from.length && typeof from[0] !== 'string') throw new Error('join.encode input should be array of strings');

      var _iterator = _createForOfIteratorHelper(from),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var i = _step.value;
          if (typeof i !== 'string') throw new Error("join.encode: non-string input=".concat(i));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return from.join(separator);
    },
    decode: function decode(to) {
      if (typeof to !== 'string') throw new Error('join.decode input should be string');
      return to.split(separator);
    }
  };
}

function padding(bits) {
  var chr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '=';
  assertNumber(bits);
  if (typeof chr !== 'string') throw new Error('padding chr should be string');
  return {
    encode: function encode(data) {
      if (!Array.isArray(data) || data.length && typeof data[0] !== 'string') throw new Error('padding.encode input should be array of strings');

      var _iterator2 = _createForOfIteratorHelper(data),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var i = _step2.value;
          if (typeof i !== 'string') throw new Error("padding.encode: non-string input=".concat(i));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      while (data.length * bits % 8) {
        data.push(chr);
      }

      return data;
    },
    decode: function decode(input) {
      if (!Array.isArray(input) || input.length && typeof input[0] !== 'string') throw new Error('padding.encode input should be array of strings');

      var _iterator3 = _createForOfIteratorHelper(input),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var i = _step3.value;
          if (typeof i !== 'string') throw new Error("padding.decode: non-string input=".concat(i));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var end = input.length;
      if (end * bits % 8) throw new Error('Invalid padding: string should have whole number of bytes');

      for (; end > 0 && input[end - 1] === chr; end--) {
        if (!((end - 1) * bits % 8)) throw new Error('Invalid padding: string has too much padding');
      }

      return input.slice(0, end);
    }
  };
}

function normalize(fn) {
  if (typeof fn !== 'function') throw new Error('normalize fn should be function');
  return {
    encode: function encode(from) {
      return from;
    },
    decode: function decode(to) {
      return fn(to);
    }
  };
}

function convertRadix(data, from, to) {
  if (from < 2) throw new Error("convertRadix: wrong from=".concat(from, ", base cannot be less than 2"));
  if (to < 2) throw new Error("convertRadix: wrong to=".concat(to, ", base cannot be less than 2"));
  if (!Array.isArray(data)) throw new Error('convertRadix: data should be array');
  if (!data.length) return [];
  var pos = 0;
  var res = [];
  var digits = Array.from(data);
  digits.forEach(function (d) {
    assertNumber(d);
    if (d < 0 || d >= from) throw new Error("Wrong integer: ".concat(d));
  });

  while (true) {
    var carry = 0;
    var done = true;

    for (var i = pos; i < digits.length; i++) {
      var digit = digits[i];
      var digitBase = from * carry + digit;

      if (!Number.isSafeInteger(digitBase) || from * carry / from !== carry || digitBase - digit !== from * carry) {
        throw new Error('convertRadix: carry overflow');
      }

      carry = digitBase % to;
      digits[i] = Math.floor(digitBase / to);
      if (!Number.isSafeInteger(digits[i]) || digits[i] * to + carry !== digitBase) throw new Error('convertRadix: carry overflow');
      if (!done) continue;else if (!digits[i]) pos = i;else done = false;
    }

    res.push(carry);
    if (done) break;
  }

  for (var _i = 0; _i < data.length - 1 && data[_i] === 0; _i++) {
    res.push(0);
  }

  return res.reverse();
}

var gcd = function gcd(a, b) {
  return !b ? a : gcd(b, a % b);
};

var radix2carry = function radix2carry(from, to) {
  return from + (to - gcd(from, to));
};

function convertRadix2(data, from, to, padding) {
  if (!Array.isArray(data)) throw new Error('convertRadix2: data should be array');
  if (from <= 0 || from > 32) throw new Error("convertRadix2: wrong from=".concat(from));
  if (to <= 0 || to > 32) throw new Error("convertRadix2: wrong to=".concat(to));

  if (radix2carry(from, to) > 32) {
    throw new Error("convertRadix2: carry overflow from=".concat(from, " to=").concat(to, " carryBits=").concat(radix2carry(from, to)));
  }

  var carry = 0;
  var pos = 0;
  var mask = Math.pow(2, to) - 1;
  var res = [];

  var _iterator4 = _createForOfIteratorHelper(data),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var n = _step4.value;
      assertNumber(n);
      if (n >= Math.pow(2, from)) throw new Error("convertRadix2: invalid data word=".concat(n, " from=").concat(from));
      carry = carry << from | n;
      if (pos + from > 32) throw new Error("convertRadix2: carry overflow pos=".concat(pos, " from=").concat(from));
      pos += from;

      for (; pos >= to; pos -= to) {
        res.push((carry >> pos - to & mask) >>> 0);
      }

      carry &= Math.pow(2, pos) - 1;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  carry = carry << to - pos & mask;
  if (!padding && pos >= from) throw new Error('Excess padding');
  if (!padding && carry) throw new Error("Non-zero padding: ".concat(carry));
  if (padding && pos > 0) res.push(carry >>> 0);
  return res;
}

function radix(num) {
  assertNumber(num);
  return {
    encode: function encode(bytes) {
      if (!(bytes instanceof Uint8Array)) throw new Error('radix.encode input should be Uint8Array');
      return convertRadix(Array.from(bytes), Math.pow(2, 8), num);
    },
    decode: function decode(digits) {
      if (!Array.isArray(digits) || digits.length && typeof digits[0] !== 'number') throw new Error('radix.decode input should be array of strings');
      return Uint8Array.from(convertRadix(digits, num, Math.pow(2, 8)));
    }
  };
}

function radix2(bits) {
  var revPadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  assertNumber(bits);
  if (bits <= 0 || bits > 32) throw new Error('radix2: bits should be in (0..32]');
  if (radix2carry(8, bits) > 32 || radix2carry(bits, 8) > 32) throw new Error('radix2: carry overflow');
  return {
    encode: function encode(bytes) {
      if (!(bytes instanceof Uint8Array)) throw new Error('radix2.encode input should be Uint8Array');
      return convertRadix2(Array.from(bytes), 8, bits, !revPadding);
    },
    decode: function decode(digits) {
      if (!Array.isArray(digits) || digits.length && typeof digits[0] !== 'number') throw new Error('radix2.decode input should be array of strings');
      return Uint8Array.from(convertRadix2(digits, bits, 8, revPadding));
    }
  };
}

function unsafeWrapper(fn) {
  if (typeof fn !== 'function') throw new Error('unsafeWrapper fn should be function');
  return function () {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return fn.apply(null, args);
    } catch (e) {}
  };
}

function checksum(len, fn) {
  assertNumber(len);
  if (typeof fn !== 'function') throw new Error('checksum fn should be function');
  return {
    encode: function encode(data) {
      if (!(data instanceof Uint8Array)) throw new Error('checksum.encode: input should be Uint8Array');
      var checksum = fn(data).slice(0, len);
      var res = new Uint8Array(data.length + len);
      res.set(data);
      res.set(checksum, data.length);
      return res;
    },
    decode: function decode(data) {
      if (!(data instanceof Uint8Array)) throw new Error('checksum.decode: input should be Uint8Array');
      var payload = data.slice(0, -len);
      var newChecksum = fn(payload).slice(0, len);
      var oldChecksum = data.slice(-len);

      for (var i = 0; i < len; i++) {
        if (newChecksum[i] !== oldChecksum[i]) throw new Error('Invalid checksum');
      }

      return payload;
    }
  };
}

exports.utils = {
  alphabet: alphabet,
  chain: chain,
  checksum: checksum,
  radix: radix,
  radix2: radix2,
  join: join,
  padding: padding
};
exports.base16 = chain(radix2(4), alphabet('0123456789ABCDEF'), join(''));
exports.base32 = chain(radix2(5), alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'), padding(5), join(''));
exports.base32hex = chain(radix2(5), alphabet('0123456789ABCDEFGHIJKLMNOPQRSTUV'), padding(5), join(''));
exports.base32crockford = chain(radix2(5), alphabet('0123456789ABCDEFGHJKMNPQRSTVWXYZ'), join(''), normalize(function (s) {
  return s.toUpperCase().replace(/O/g, '0').replace(/[IL]/g, '1');
}));
exports.base64 = chain(radix2(6), alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'), padding(6), join(''));
exports.base64url = chain(radix2(6), alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'), padding(6), join(''));

var genBase58 = function genBase58(abc) {
  return chain(radix(58), alphabet(abc), join(''));
};

exports.base58 = genBase58('123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz');
exports.base58flickr = genBase58('123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ');
exports.base58xrp = genBase58('rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz');
var XMR_BLOCK_LEN = [0, 2, 3, 5, 6, 7, 9, 10, 11];
exports.base58xmr = {
  encode: function encode(data) {
    var res = '';

    for (var i = 0; i < data.length; i += 8) {
      var block = data.subarray(i, i + 8);
      res += exports.base58.encode(block).padStart(XMR_BLOCK_LEN[block.length], '1');
    }

    return res;
  },
  decode: function decode(str) {
    var res = [];

    for (var i = 0; i < str.length; i += 11) {
      var slice = str.slice(i, i + 11);
      var blockLen = XMR_BLOCK_LEN.indexOf(slice.length);
      var block = exports.base58.decode(slice);

      for (var j = 0; j < block.length - blockLen; j++) {
        if (block[j] !== 0) throw new Error('base58xmr: wrong padding');
      }

      res = res.concat(Array.from(block.slice(block.length - blockLen)));
    }

    return Uint8Array.from(res);
  }
};

var base58check = function base58check(sha256) {
  return chain(checksum(4, function (data) {
    return sha256(sha256(data));
  }), exports.base58);
};

exports.base58check = base58check;
var BECH_ALPHABET = chain(alphabet('qpzry9x8gf2tvdw0s3jn54khce6mua7l'), join(''));
var POLYMOD_GENERATORS = [0x3b6a57b2, 0x26508e6d, 0x1ea119fa, 0x3d4233dd, 0x2a1462b3];

function bech32Polymod(pre) {
  var b = pre >> 25;
  var chk = (pre & 0x1ffffff) << 5;

  for (var i = 0; i < POLYMOD_GENERATORS.length; i++) {
    if ((b >> i & 1) === 1) chk ^= POLYMOD_GENERATORS[i];
  }

  return chk;
}

function bechChecksum(prefix, words) {
  var encodingConst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var len = prefix.length;
  var chk = 1;

  for (var i = 0; i < len; i++) {
    var c = prefix.charCodeAt(i);
    if (c < 33 || c > 126) throw new Error("Invalid prefix (".concat(prefix, ")"));
    chk = bech32Polymod(chk) ^ c >> 5;
  }

  chk = bech32Polymod(chk);

  for (var _i2 = 0; _i2 < len; _i2++) {
    chk = bech32Polymod(chk) ^ prefix.charCodeAt(_i2) & 0x1f;
  }

  var _iterator5 = _createForOfIteratorHelper(words),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var v = _step5.value;
      chk = bech32Polymod(chk) ^ v;
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  for (var _i3 = 0; _i3 < 6; _i3++) {
    chk = bech32Polymod(chk);
  }

  chk ^= encodingConst;
  return BECH_ALPHABET.encode(convertRadix2([chk % Math.pow(2, 30)], 30, 5, false));
}

function genBech32(encoding) {
  var ENCODING_CONST = encoding === 'bech32' ? 1 : 0x2bc830a3;

  var _words = radix2(5);

  var fromWords = _words.decode;
  var toWords = _words.encode;
  var fromWordsUnsafe = unsafeWrapper(fromWords);

  function encode(prefix, words) {
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 90;
    if (typeof prefix !== 'string') throw new Error("bech32.encode prefix should be string, not ".concat(_typeof(prefix)));
    if (!Array.isArray(words) || words.length && typeof words[0] !== 'number') throw new Error("bech32.encode words should be array of numbers, not ".concat(_typeof(words)));
    var actualLength = prefix.length + 7 + words.length;
    if (limit !== false && actualLength > limit) throw new TypeError("Length ".concat(actualLength, " exceeds limit ").concat(limit));
    prefix = prefix.toLowerCase();
    return "".concat(prefix, "1").concat(BECH_ALPHABET.encode(words)).concat(bechChecksum(prefix, words, ENCODING_CONST));
  }

  function decode(str) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 90;
    if (typeof str !== 'string') throw new Error("bech32.decode input should be string, not ".concat(_typeof(str)));
    if (str.length < 8 || limit !== false && str.length > limit) throw new TypeError("Wrong string length: ".concat(str.length, " (").concat(str, "). Expected (8..").concat(limit, ")"));
    var lowered = str.toLowerCase();
    if (str !== lowered && str !== str.toUpperCase()) throw new Error("String must be lowercase or uppercase");
    str = lowered;
    var sepIndex = str.lastIndexOf('1');
    if (sepIndex === 0 || sepIndex === -1) throw new Error("Letter \"1\" must be present between prefix and data only");
    var _ref = [str.slice(0, sepIndex), str.slice(sepIndex + 1)],
        prefix = _ref[0],
        _words = _ref[1];
    if (_words.length < 6) throw new Error('Data must be at least 6 characters long');
    var words = BECH_ALPHABET.decode(_words).slice(0, -6);
    var sum = bechChecksum(prefix, words, ENCODING_CONST);
    if (!_words.endsWith(sum)) throw new Error("Invalid checksum in ".concat(str, ": expected \"").concat(sum, "\""));
    return {
      prefix: prefix,
      words: words
    };
  }

  var decodeUnsafe = unsafeWrapper(decode);

  function decodeToBytes(str) {
    var _decode = decode(str, false),
        prefix = _decode.prefix,
        words = _decode.words;

    return {
      prefix: prefix,
      words: words,
      bytes: fromWords(words)
    };
  }

  return {
    encode: encode,
    decode: decode,
    decodeToBytes: decodeToBytes,
    decodeUnsafe: decodeUnsafe,
    fromWords: fromWords,
    fromWordsUnsafe: fromWordsUnsafe,
    toWords: toWords
  };
}

exports.bech32 = genBech32('bech32');
exports.bech32m = genBech32('bech32m');
exports.utf8 = {
  encode: function encode(data) {
    return new TextDecoder().decode(data);
  },
  decode: function decode(str) {
    return new TextEncoder().encode(str);
  }
};
exports.hex = chain(radix2(4), alphabet('0123456789abcdef'), join(''), normalize(function (s) {
  if (typeof s !== 'string' || s.length % 2) throw new TypeError("hex.decode: expected string, got ".concat(_typeof(s), " with length ").concat(s.length));
  return s.toLowerCase();
}));
var CODERS = {
  utf8: exports.utf8,
  hex: exports.hex,
  base16: exports.base16,
  base32: exports.base32,
  base64: exports.base64,
  base64url: exports.base64url,
  base58: exports.base58,
  base58xmr: exports.base58xmr
};
var coderTypeError = "Invalid encoding type. Available types: ".concat(Object.keys(CODERS).join(', '));

var bytesToString = function bytesToString(type, bytes) {
  if (typeof type !== 'string' || !CODERS.hasOwnProperty(type)) throw new TypeError(coderTypeError);
  if (!(bytes instanceof Uint8Array)) throw new TypeError('bytesToString() expects Uint8Array');
  return CODERS[type].encode(bytes);
};

exports.bytesToString = bytesToString;
exports.str = exports.bytesToString;

var stringToBytes = function stringToBytes(type, str) {
  if (!CODERS.hasOwnProperty(type)) throw new TypeError(coderTypeError);
  if (typeof str !== 'string') throw new TypeError('stringToBytes() expects string');
  return CODERS[type].decode(str);
};

exports.stringToBytes = stringToBytes;
exports.bytes = exports.stringToBytes;